import Razorpay from "razorpay";
import axiosClient from "../axiosClient";

//! FUNCTION TO CREATE ORDER FOR PAYMENT USING RAZORPAY SDK

export const createOrder = async ({ planId }: { planId: string }) => {
  try {
    const response = await axiosClient.post("/api/orders/create", { planId });
    return response;
  } catch (error) {
    console.error("Error creating order", error);
    throw error;
  }
};

interface OrderDetails {
  amount: number;
  currency: string;
  id: string;
  status: string;
}

interface verifySignatureProps {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export const verifySignature = async (orderDetails: verifySignatureProps) => {
  const payload = {
    razorpayPaymentId: orderDetails.razorpay_payment_id,
    razorpayOrderId: orderDetails.razorpay_order_id,
    razorpaySignature: orderDetails.razorpay_signature,
  };
  try {
    const response = await axiosClient.post("/api/orders/verify", payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
